import { YaraTestRunResult } from "./yaratestrun";

export type YaraTestRunMatchIconProps = {
  latest: boolean;
  onClick?: () => void;
};

export type YaraTestRunMatchProps = {
  matches: Array<YaraTestRunResult>;
  status?: number;
  message?: string;
  onClick?: (resultId: number) => void;
};
